var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugHouseholdGSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27,2H5C3.3457031,2,2,3.3457031,2,5v22c0,1.6542969,1.3457031,3,3,3h22c1.6542969,0,3-1.3457031,3-3V5 C30,3.3457031,28.6542969,2,27,2z M28,27c0,0.5517578-0.4482422,1-1,1H5c-0.5517578,0-1-0.4482422-1-1V5 c0-0.5517578,0.4482422-1,1-1h22c0.5517578,0,1,0.4482422,1,1V27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,18H7c-0.5527344,0-1,0.4472656-1,1v4c0,0.5527344,0.4472656,1,1,1h7c0.5527344,0,1-0.4472656,1-1v-4 C15,18.4472656,14.5527344,18,14,18z M13,22H8v-2h5V22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,16h4c0.5527344,0,1-0.4472656,1-1V8c0-0.5527344-0.4472656-1-1-1h-4c-0.5527344,0-1,0.4472656-1,1v7 C13,15.5527344,13.4472656,16,14,16z M15,9h2v5h-2V9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,18h-7c-0.5527344,0-1,0.4472656-1,1v4c0,0.5527344,0.4472656,1,1,1h7c0.5527344,0,1-0.4472656,1-1v-4 C26,18.4472656,25.5527344,18,25,18z M24,22h-5v-2h5V22z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugHouseholdGSmall);
export default __webpack_public_path__ + "static/media/plug-household-g--small.c3680a52ba084815abab7d937d28f5eb.svg";
export { ForwardRef as ReactComponent };